module.exports = __webpack_public_path__ + "img/slide4.19d8b950.png";